module.exports = __webpack_public_path__ + "static/img/RAC1810_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAC1810_1.png
// module id = AWBQ
// module chunks = 0